import { buildUrl } from '@/shared/utils/url';

const YANDEX_MAPS_ORIGIN = 'https://yandex.ru/maps/';

/** Ссылка на точку в Яндекс Картах: центр, зум и пин (`pt`). */
export const buildYandexMapsPlaceUrl = (longitude: number, latitude: number, zoom = 15) => {
  const point = [longitude, latitude].join(',');

  return buildUrl(YANDEX_MAPS_ORIGIN, {
    ll: point,
    pt: point,
    z: zoom,
  });
};

export const isYandexMapsPlaceUrl = (href: string) => {
  try {
    const { hostname, pathname } = new URL(href);
    const isYandexHost =
      hostname === 'yandex.ru' ||
      hostname.endsWith('.yandex.ru') ||
      hostname === 'yandex.com' ||
      hostname.endsWith('.yandex.com');

    return isYandexHost && (pathname === '/maps' || pathname.startsWith('/maps/'));
  } catch {
    return false;
  }
};

export const isOpenYandexMapsControl = (target: Element) => {
  const control = target.closest('a, button, [role="button"]');

  if (!control) {
    return false;
  }

  if (control instanceof HTMLAnchorElement && isYandexMapsPlaceUrl(control.href)) {
    return true;
  }

  return /открыть\s+(в\s+)?яндекс\s+карт/i.test(control.textContent);
};
